<nz-tabset [(nzSelectedIndex)]="selectedTabIndex" (nzSelectedIndexChange)="onTabChange($event)" [nzSize]="'small'"
  nzType="card" class="m-[-10px] p-0">
  <nz-tab *ngFor="let tab of availableSubTabs; let i = index" [nzTitle]="tab">
    <ng-template nz-tab>
      <ng-container *ngIf="selectedTabIndex === i">
        <ng-container *ngIf="getSubTabComponentIndex(i) === 0">
          <app-gatewayManagement></app-gatewayManagement>
        </ng-container>
        <ng-container *ngIf="getSubTabComponentIndex(i) === 1">
          <app-sensorManagement></app-sensorManagement>
        </ng-container>
        <ng-container *ngIf="getSubTabComponentIndex(i) === 2">
          <app-hooterManagement></app-hooterManagement>
        </ng-container>
      </ng-container>
    </ng-template>
  </nz-tab>
</nz-tabset>